var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"svg_wrapper",attrs:{"id":_vm.localId}},[_vm._v("This is chart component.")])}
var staticRenderFns = []

export { render, staticRenderFns }